export default () => ({
  blacklist: [],
});
